export default function Priceplantable(){
    return(
        <div className="mt-[5%]">
          <div className="font-bold lg:text-4xl text-lg text-center text-[#244B69] lg:p-10 p-5 bg-[#8E8E8E]/[8%] ">Pricing Plans</div>
          <div className="w-full"><img className="w-full" src="../images/pricetable.png" alt="" /></div>
        </div>
    )
}